import { SearchIcon } from 'lucide-react';
import { Input } from './ui/input';
import { cn } from '../utils/styling';
import React from 'react';

type Props = {
  label: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  onPointerDown?: (e: React.PointerEvent<HTMLInputElement>) => void;
  onFocus?: React.FocusEventHandler<HTMLInputElement> | undefined;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
  onClick?: (e: React.MouseEvent<HTMLInputElement>) => void;
  onTouchStart?: (e: React.TouchEvent<HTMLInputElement>) => void;
};

const Search = React.forwardRef<HTMLInputElement, Props>(
  (
    {
      label,
      value,
      onChange,
      className,
      onKeyDown,
      onPointerDown,
      onBlur,
      onFocus,
      onClick,
      onTouchStart,
    },
    ref
  ) => {
    return (
      <Input
        ref={ref}
        label={label}
        showLabel={false}
        value={value}
        icon={
          <SearchIcon className="size-7 ml-2 text-secondary dark:text-secondary-foreground" />
        }
        onChange={onChange}
        onKeyDown={onKeyDown}
        onPointerDown={onPointerDown}
        onFocus={onFocus}
        onBlur={onBlur}
        onClick={onClick}
        onTouchStart={onTouchStart}
        className={cn(
          'rounded-full h-[4.2rem] p3 bg-[#e8e8e8] dark:bg-secondary placeholder:text-secondary dark:placeholder:text-secondary-foreground',
          className
        )}
      />
    );
  }
);

Search.displayName = 'Search';

export { Search };
